<template>
  <div class="background-main">
    <v-container style="min-height: 950px;">
      <v-row justify="center" align="center" style="min-height: 950px;">
        <v-col cols="12" md="8" class="d-flex align-center">
          <v-card
            class="my-12 box-shadow border-radius"
            width="100%">
            <v-row justify="center" align="center">
              <v-col cols="12" md="6" class="background-login hidden-md-and-down">
                <v-img
                  class="ma-auto my-5"
                  contain
                  height="auto"
                  width="200"
                  :src="require('../../assets/logo/logo_white.png')">
                </v-img>
                <p class="body-2 white--text text-center my-10 px-12 line-text-first">
                  MiPRO telah menyelesaikan berbagai macam masalah para pelaku property dan mencatatkan kinerja positif.
                </p>
              </v-col>
              <v-col cols="12" md="6" class="pa-12">
                <div class="d-flex align-center mb-5">
                  <v-divider color="white"></v-divider>
                  <div class="subtitle-2 mx-2 font-weight-bold green--text text-lighten-2">FORM LOGIN</div>
                  <v-divider color="white"></v-divider>
                </div>
                <ValidationObserver ref="observer">
                  <v-form class="text-left mb-5">
                    <ValidationProvider name="Username" rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-on:keyup.enter="save"
                        outlined
                        dense
                        single-line
                        :color="style.primary"
                        placeholder="Username"
                        v-model="form.username"
                        :error-messages="errors"
                        required>
                      </v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      name="Password"
                      rules="required|min:5|max:20"
                      v-slot="{ errors }">
                      <v-text-field
                        v-on:keyup.enter="save"
                        class="mt-2 mb-1"
                        outlined
                        :color="style.primary"
                        dense
                        single-line
                        placeholder="Password"
                        v-model="form.password"
                        :type="show ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show = !show"
                        :error-messages="errors"
                        required>
                      </v-text-field>
                    </ValidationProvider>
                  </v-form>
                </ValidationObserver>
                <div class="text-center">
                  <v-alert type="error" text dense prominent 
                    v-show="error.message.length > 0"
                    v-html="error.message">
                  </v-alert>
                  <v-btn
                    block
                    elevation="3"
                    :color="style.primary"
                    :disabled="process.run"
                    :loading="process.run"
                    v-on:keyup.enter="save"
                    @click="save"
                    class="white--text text-capitalize">
                    Masuk
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { TokenService } from "../../service/Storage.Service";
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: "",
          password: "",
          type: "company",
          device: ""
        },
        process: {
          run: false
        },
        error: {
          message: ""
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    mounted () {
      if (this.$route.query.username !== undefined && this.$route.query.password !== undefined) {
        this.form.username = this.$route.query.username
        this.form.password = this.$route.query.password

        this.saveLogin()
      }
    },
    methods: {
      async save() {
        this.error.message = ""
        const isValid = await this.$refs.observer.validate()
        
        if (isValid) {
          this.saveLogin()
        }
      },
      async saveLogin() {
        this.process.run = true
        await post(`login`, {
          data: {
            username: this.form.username,
            password: this.form.password,
            user_type: this.form.type,
            device_id: this.form.device
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            TokenService.saveToken(
              res.data.token,
              JSON.stringify(res.data.profile)
            )
            window.location = `${process.env.BASE_URL}`
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
.background-main {
  background: url("../../assets/image/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 940px;
}
.background-login {
  background: url("../../assets/image/login.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 100px 0px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
}
</style>